import { create } from 'zustand';
import type { AccountStanding, StandingAction } from '@spawnwire/shared';
import { http } from '../../lib/api';

interface StandingState {
  /** Your account standing, once loaded. */
  standing: AccountStanding | null;
  /** The ban in force, which replaces the whole app with the ban screen. */
  ban: StandingAction | null;
}

export const useStanding = create<StandingState>(() => ({ standing: null, ban: null }));

export const standing = {
  async load(): Promise<AccountStanding> {
    const s = await http.get<AccountStanding>('/users/@me/standing');
    useStanding.setState({ standing: s, ban: s.ban });
    return s;
  },
  set(s: AccountStanding) {
    useStanding.setState({ standing: s, ban: s.ban });
  },
  banned(ban: StandingAction) {
    useStanding.setState({ ban });
  },
  /** Updates one action in place, e.g. after appealing it or acknowledging it. */
  patch(id: string, patch: Partial<StandingAction>) {
    useStanding.setState((s) => ({
      standing: s.standing ? { ...s.standing, actions: s.standing.actions.map((a) => (a.id === id ? { ...a, ...patch } : a)) } : s.standing,
      ban: s.ban?.id === id ? { ...s.ban, ...patch } : s.ban,
    }));
  },
  clear() {
    useStanding.setState({ standing: null, ban: null });
  },
};
